import React, { Component } from 'react'
import APICalendar from '../api/APICalendar'
import '../styles/CalendarView.css'
import DateTile from './DateTile'
import APICalendarRequest from '../api/APICalendarRequest'
import APIGenericRequest from '../api/APIGenericRequest'

class Calendar extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			siteId: localStorage.getItem("siteId"),
			days: [],
			dateTiles: [],
			dateToday: new Date(),
			dtKeyCounter: 0,
			extendedActivityList: {}
		}
		this.setMonthView = this.setMonthView.bind(this)
		this.setActivity = this.setActivity.bind(this)
		this.getAllActivitiesBySiteId = this.getAllActivitiesBySiteId.bind(this)
		this.onSignal = this.onSignal.bind(this)
		this.addToExtendedActivities = this.addToExtendedActivities.bind(this)
		this.getServerDateTime = this.getServerDateTime.bind(this)
	}

	componentWillMount() {
		this.getServerDateTime()
		const days = APICalendar.getAllDaysOfTheWeek()
		for(const v of days) {
			this.state.days.push(<div className="calendar-grid-item">{v}</div>)
		}
		this.getAllActivitiesBySiteId(this.props.viewMonthYear)
	}

	getServerDateTime() {
		const apiReq = APIGenericRequest.getServerDateTime(this.state.accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const date = new Date(response.results.date_time)
			this.setState({
				dateToday: date
			})
		})
	}

	componentDidUpdate(prevProps) {
		if(this.props.viewMonthYear != prevProps.viewMonthYear) {
			this.getAllActivitiesBySiteId(this.props.viewMonthYear)
		}
		if(this.props.activity != prevProps.activity) {
			this.setActivity(this.props.activity)
		}
	}

	getAllActivitiesBySiteId(viewMonthYear) {
		if(viewMonthYear.month === 0) {
			var prevMonth = 12
			var nextMonth = 2
			var startYear = viewMonthYear.year - 1
			var endYear = viewMonthYear.year
		}
		else if(viewMonthYear.month === 11) {
			var prevMonth = 10
			var nextMonth = 1
			var startYear = viewMonthYear.year
			var endYear = viewMonthYear.year + 1
		}
		else {
			var prevMonth = viewMonthYear.month
			var nextMonth = viewMonthYear.month + 2
			var startYear = viewMonthYear.year
			var endYear = viewMonthYear.year
		}
		const startDate = startYear + "-" + (prevMonth) + "-23"
		const endDate = endYear + "-" + (nextMonth) + "-06"
		const apiReq = APICalendarRequest.getAllActivitiesBySiteId(this.state.accessToken, this.state.siteId, startDate, endDate);
		apiReq.then((response) => {
			if(response.status === "FAILED") {
			this.setMonthView(this.props.viewMonthYear)
				return;
			}
			const activities = {}
			for(const v of response.results.rows) {
				const d = new Date(v.start_date)
				const k = d.toDateString()
				if(activities[k] == null) {
					activities[k] = []
				}
				activities[k].push(v)
			}
			this.setMonthView(this.props.viewMonthYear, activities)
			this.setState({activities: activities})
		});
	}

	setMonthView(viewMonthYear, activities) {
		const dateTiles = []
		let tileCount = 1
		const viewMonth = new Date(viewMonthYear.year, viewMonthYear.month)
		const date = new Date(viewMonthYear.year, viewMonthYear.month)
		date.setDate(viewMonth.getDate() - viewMonth.getDate())
		if(date.getDay() != 6) {
			tileCount += date.getDay()
			date.setDate(date.getDate() - date.getDay())
		}
		else {
			tileCount -= 1
			date.setDate(date.getDate() + 1)
		}
		const lastDate = new Date(viewMonth.getFullYear(), viewMonth.getMonth()+1, 0);
		tileCount += lastDate.getDate()
		tileCount += 6-lastDate.getDay()
		// const dateToday = new Date()
		for(let i=1; i<=tileCount; i++) {
			let isToday = false
			let isCurrentMonth = true
			let status = 1
			// if(date.toDateString() === dateToday.toDateString()) {
			if(date.toDateString() === this.state.dateToday.toDateString()) {
					isToday = true
			}
			if(date.getMonth() != viewMonth.getMonth()) {
				isCurrentMonth = false
				status = 0
			}
			let activityList = []
			const statusIds = []
			if(activities != null) {
				if(activities.hasOwnProperty(date.toDateString())) {
					activityList = activities[date.toDateString()]
					for(const v of activityList) {
						statusIds.push(v.activity_status_id)
						if(v.start_date != v.end_date) {
							this.addToExtendedActivities(date.toDateString(), v)
						}
					}
					status = checkStatus(date.toDateString(), statusIds, this.state.dateToday)
				}
			}
			if(this.state.extendedActivityList != null) {
				if(this.state.extendedActivityList.hasOwnProperty(date.toDateString())) {
					for(const v in this.state.extendedActivityList[date.toDateString()]) {
						statusIds.push(this.state.extendedActivityList[date.toDateString()][v].activity_status_id)
						activityList.push(this.state.extendedActivityList[date.toDateString()][v])
					}

					status = checkStatus(date.toDateString(), statusIds, this.state.dateToday)
				}
			}
			dateTiles.push(<DateTile date={date.getDate()} month={date.getMonth()}
				dateString={date.toDateString()}
				activities={activityList}
				isToday={isToday}
				isCurrentMonth={isCurrentMonth}
				status={status}
				onSignal={this.onSignal}
				key={this.state.dtKeyCounter++} />)
			date.setDate(date.getDate() + 1)
		}
		this.setState({dateTiles: dateTiles})
	}

	addToExtendedActivities(key, activity) {
		const startDate = new Date(activity.start_date)
		const endDate = new Date(activity.end_date)
		var st = startDate.getTime()
		var et = endDate.getTime()
		const diff = (et-st)/(24*3600*1000)
		const activities = []
		for(let i=1; i<=diff; i++) {
			const date = new Date(key)
			date.setDate(startDate.getDate() + i)
			if(this.state.extendedActivityList[date.toDateString()] == null) {
				this.state.extendedActivityList[date.toDateString()] = {}
			}
			this.state.extendedActivityList[date.toDateString()][activity.activity_id] = activity
		}
	}

	onSignal(view, id, stat) {
		this.props.onSignal(view, id, stat)
	}

	setActivity(activity) {
		const activities = {}
		for(const k in this.state.activities) {
			const dateActivities = this.state.activities[k]
			for(const v of dateActivities) {
				if(activity.id == v.activity_type_id || activity.id === "0") {
					if(activities[k] == null) {
						activities[k] = []
					}
					activities[k].push(v)
				}
			}
		}
		this.setMonthView(this.props.viewMonthYear, activities)
	}

	render() {
		const view = <div id="calendar">
			<div className="calendar-grid-container">
				{this.state.days}
			</div>
			<div className="calendar-grid-container" id="calendar-tiles">
					{this.state.dateTiles}
			</div>
		</div>
		return(view)
	}
}

const checkStatus = (date, statusIds, dateToday) => {
	// const d = new Date()
	const pd = Date.parse(dateToday.toDateString())
	const pDate = Date.parse(date)
	let status
	if(pDate < pd) {
		status = 3 // "done"
		for(const v of statusIds) {
			if(v === 1) {
				status = 2 // "attention"
				break
			}
		}
	}
	else if(pDate > pd) {
		status = 5 // "upcoming"
	}
	else if(pDate == pd) {
		status = 4 // "happening"
	}
	return(status)
}

export default Calendar
